var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Footer',{staticClass:"FooterFinancing"},[_c('div',{attrs:{"slot":"blobs"},slot:"blobs"},[_c('Blob',{staticClass:"top-left",attrs:{"name":"footer-blob-top-left"}})],1),_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }